/** @typedef {import("./resources").Resource} Resource */
import React from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {Container} from "reactstrap";
import {listTarget} from "../../shared/utils/listMemory";
import ResourceForm from "./ResourceForm";
import {newDefaults} from "./resources";

/** @param {{resource: Resource}} props */
const ResourceNew = ({resource}) => {
    const navigate = useNavigate();
    const {singular, url, path, fields} = resource;

    return (
        <Container className="mt-4 mb-5" style={{maxWidth: 640}}>
            <h3 className="mb-3">Novo {singular}</h3>
            <ResourceForm
                fields={fields}
                initial={newDefaults[url]}
                submitLabel={`Criar ${singular}`}
                onCancel={() => {
                    // back to the list as it was, with its filters and scroll
                    const back = listTarget(path);
                    navigate(back.to, {state: back.state});
                }}
                onSubmit={async (payload) => {
                    const {data} = await axios.post(url, payload);
                    navigate(`${path}/${data.id}`, {replace: true});
                }}
            />
        </Container>
    );
};

export default ResourceNew;
